module.exports = __webpack_public_path__ + "static/perfect-it-9a48d82d8917ca4b94080e59a2e7af37.png";